











import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'BaseBaseButtonVertical',
  inheritAttrs: false,
  props: { text: { type: Boolean, default: true } },
  emits: ['click'],
});
